import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core'
import { AbstractControl, ControlContainer, FormGroupDirective, ReactiveFormsModule } from '@angular/forms'
import { createFormControlBinding } from '@core/utils/form-utils'
import { InputNumber } from 'primeng/inputnumber'
import { InputNumberMode } from 'primeng/types/inputnumber'
import { IftaLabel } from 'primeng/iftalabel'

@Component({
  selector: 'albert-inputnumber',
  standalone: true,
  imports: [ReactiveFormsModule, InputNumber, IftaLabel],
  templateUrl: './albert-inputnumber.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class AlbertInputnumberComponent {
  public readonly groupName = input.required<string>()
  public readonly label = input.required<string>()
  public readonly inputId = input.required<string>()
  public readonly controlName = input<string>('value')
  public readonly mode = input<InputNumberMode>('decimal')
  public readonly currency = input<string>('EUR')
  public readonly disabled = input<boolean>(false)
  public readonly required = input<boolean>(false)
  public readonly showButtons = input<boolean>(false)
  public readonly minValue = input<number>()
  public readonly maxValue = input<number>()
  public readonly fractionDigits = input<number>()

  private readonly parentGroupDir = inject(FormGroupDirective)
  private readonly binding = createFormControlBinding(this.groupName, this.controlName, this.disabled)

  public readonly control = this.binding.control

  public get isUpdatedByOrigami(): boolean {
    return this.binding.isUpdatedByOrigami()
  }

  public get showRequiredHint(): boolean {
    if (!this.required()) return false

    const val: unknown = this.control()?.value
    return (val === null || val === undefined) && !this.disabled()
  }

  public get showInvalidState(): boolean {
    const ctrl = this.control()
    return !!ctrl && ctrl.invalid && (ctrl.dirty || ctrl.touched) && !this.disabled()
  }

  private get group(): AbstractControl | null {
    return this.parentGroupDir.form.get(this.groupName())
  }
}
